define.alias("shared/components/shared/mavely/links/mobile-tabs", "media/components/shared/mavely/links/mobile-tabs");